<template>
  <div class="ll-add-member-input-list">
    <ValidationObserver ref="formObserver" class="ll-add-member-input-list_input">
      <div class="input-item ml-15">
        <StateInputButton
          v-model="memberData.name"
          :title="$t('人員名稱')"
          :placeholder="$t('輸入')"
          rules="required"
        />
      </div>
      <div class="input-item ml-15">
        <StateInputButton
          v-model="memberData.email"
          :title="$t('信箱')"
          :placeholder="$t('輸入')"
          rules="required|email"
        />
      </div>
      <div v-if="_roleListLength" class="input-item">
        <WsTextButton001 no-padding primary @click="$_characterPopupOpen()">
          {{ $t('設定') }}
        </WsTextButton001>
        <LvDropdownMultiCategorySelect
          v-model="memberData.character"
          outline
          label="角色設定"
          title="角色設定"
          :placeholder="$t('選擇')"
          :menu-items="roleList"
          @input="$_changeMemberCharacter($event)"
        />
      </div>
      <div v-if="_hasRole" class="input-item ml-15">
        <LvDropdownMultiSystemClasses
          v-model="memberData.systemClasses"
          :title="$t('限閱領域')"
          :placeholder="$t('選擇')"
          :propsMenuItems="multipleSystemClassMenu"
        />
      </div>
      <div v-if="_hasRole && organizationFactoryList.length" class="input-item ml-15">
        <LvStateDropDownSelectMultiLayer
          v-model="memberData.organizationFactoryScope"
          outline
          :all-select-text="$t('所有轄下單位')"
          :title="$t('限閱轄下單位')"
          :placeholder="$t('選擇')"
          :items="organizationFactoryList"
          :layerKey="'child_factories'"
        />
      </div>
    </ValidationObserver>
    <div class="ll-add-member-input-list_button">
      <WsButton001 :isloading="isloading" width-stretch @click="$_addMemberClick()">
        {{ $t('下一步') }}
      </WsButton001>
    </div>
    <LvWarningPopup ref="LvWarningPopup" />
  </div>
</template>
<script>
import { ValidationObserver } from 'vee-validate';
import userRoleService from '@/service/api/v1/user_factory_role';

export default {
  components: {
    ValidationObserver,
  },
  props: {
    isAccountNumberFull: {
      type: Boolean,
      default: false,
    },
    roleList: {
      type: Array,
      default() {
        return [];
      },
    },
    scopeList: {
      type: Array,
      default() {
        return [
          {
            title: '權限列表',
            menu: [
              {
                text: '權限1',
                value: ['aa', 'bb'],
              },
              {
                text: '權限2',
                value: ['aa', 'bb'],
              },
              {
                text: '權限3',
                value: ['aa', 'bb'],
              },
            ],
          },
        ];
      },
    },
    organizationFactoryList: {
      type: Array,
      default() {
        return [];
      },
    },
    multipleSystemClassMenu: {
      type: Array,
      default: undefined,
    },
  },
  data() {
    return {
      isloading: false,
      memberData: {
        name: '',
        email: '',
        character: [[], []],
        systemClasses: [],
        organizationFactoryScope: [],
      },
      characterDropdownMenuItem: {
        placeholder: this.$t('選擇'),
        selectedMenuItem: '',
        menuItems: [
          {
            id: 'manager',
            textLabel: this.$t('管理者'),
          },
          {
            id: 'supervisor',
            textLabel: this.$t('監督者'),
          },
          {
            id: 'exclusive_personnel',
            textLabel: this.$t('專責人員'),
          },
          {
            id: 'no_permission',
            textLabel: this.$t('無權限'),
          },
        ],
      },
    };
  },
  computed: {
    _hasRole() {
      return userRoleService.hasRole(this.memberData.character);
    },
    _roleListLength() {
      let hasRole = false;
      this.roleList.forEach(role => {
        if (role.menu.length) hasRole = true;
      });
      return hasRole;
    },
  },
  methods: {
    $_addPopupOpen() {
      this.$emit('add-open');
    },
    async $_addMemberClick() {
      if (this.isAccountNumberFull) {
        this.$_addPopupOpen();
        return;
      }
      const isValidate = await this.$refs.formObserver.validate();
      if (!isValidate) {
        this.$refs.LvWarningPopup.$_onOpenPopup();
        return;
      }
      this.isloading = true;
      this.$emit('add-member-next', this.memberData);
      this.isloading = false;
      // this.$_clearData();
    },
    $_characterPopupOpen() {
      this.$emit('btn-click');
      this.$emit('no-scroll');
    },
    $_clearData() {
      this.memberData = {
        name: '',
        email: '',
        character: [[], []],
        systemClasses: [],
        organizationFactoryScope: [],
      };
    },
    $_changeMemberCharacter($event) {
      this.$emit('character', $event);
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/component/ll-add-member-input-list';
</style>
